import { MutationHookOptions, gql } from '@apollo/client';

import { productAppQuery } from 'routes/marketplace-ede/queries/productApplication/getProductApp';
import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'POST_ELIGIBILITY';

const usePostEligibilityMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const POST_ELIGIBILITY_MUTATION = gql`
    mutation PostEligibility($applicationId: ID!) {
      ${queryName} (applicationId: $applicationId) {
        eligibility
        parsedApplicants
        productApplication {
          ${productAppQuery}
        }
      }
    }
  `;

  return useEdeMutation(POST_ELIGIBILITY_MUTATION, options);
};

export default usePostEligibilityMutation;
